import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Dashboard as DashboardIcon } from '@mui/icons-material';

const Dashboard = () => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <DashboardIcon sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
        <Typography variant="h4" component="h1">
          Dashboard
        </Typography>
      </Box>
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Dashboard - Coming Soon
        </Typography>
      </Paper>
    </Box>
  );
};

export default Dashboard;
